export const chevronRightStyles = theme => ({
  color: theme.palette.primary.main,
});

export const labelWrapperStyles = theme => ({
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const linkStyles = theme => ({
  [theme.breakpoints.down('md')]: {
    borderTop: `1px solid ${theme.palette.graphic.light}`,
    padding: '16px 18px 16px 16px',
  },
  '&:hover': {
    backgroundColor: theme.palette.secondary.light,
  },
  borderBottom: `1px solid ${theme.palette.graphic.light}`,
  display: 'flex',
  flexDirection: 'column',
  jusifyContent: 'center',
  padding: theme.spacing(3, 2.5, 2.5, 3),
  textDecoration: 'none',
  width: '100%',
});

export const linkActiveStyles = theme => ({
  backgroundColor: theme.palette.secondary.light,
});

export const sortBlockStyles = theme => ({
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

export const timeBlockStyles = theme => ({
  [theme.breakpoints.down('md')]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    marginTop: 6,
    width: 'calc(100% - 12px)',
  },
  display: 'flex',
  flex: '0 0 calc(100% - 196px)',
  justifyContent: 'space-between',
});
